import { useEffect } from 'react';
import { init as initApm } from '@elastic/apm-rum';

const ElasticApm = ({ children }) => {
  useEffect(() => {
    const isActive = ['production', 'development'].includes(process.env.NODE_ENV as string);
    const serviceVersion = `${process.env.GATSBY_PAYMENT_MODE === 'true' ? 'paymentMode-' : ''}${
      process.env.GATSBY_BRAND
    }-${process.env.GATSBY_GIT_COMMIT_HASH}`;

    initApm({
      serviceName: 'oat-front-end',
      serviceVersion,
      active: isActive,
      serverUrl: process.env.GATSBY_APM_SERVER_URL,
      environment: process.env.NODE_ENV,
    });
  }, []);
  return children;
};

export default ElasticApm;
